import { render, staticRenderFns } from "./Project.yaml?vue&type=template&id=0e209e54&component"
import script from "./Project.yaml?vue&type=script&lang=ts&component"
export * from "./Project.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports